import type { EdgeConfig } from './schema.ts'

export const MockEdgeConfig: EdgeConfig = {
  consoleMethods: ['debug', 'info', 'warn', 'error'],
  metaTagTimeout: '10m',
  debugFilter:
    'magicsky:ubs-finance-manager,magicsky:service:ubs,magicsky:service:finance',
  launchDarklyStream: true,
  inngestSecuredTime: 1761724800,
  displayMaintenance: false,
  maintenanceConfig: {
    message: null,
    estimatedDuration: null,
    title: null,
    subtitle: null,
  },
  auth: {
    nbf: 1768318118,
    mntn: {
      issuer: 'issuer',
      jwksUri: 'jwksUri',
      // Optional field set deliberately: the compile gate on this mock only
      // catches missing required fields, and tests should exercise the
      // multi-issuer path.
      additionalIssuers: [
        {
          issuer: 'additionalIssuer',
          jwksUri: 'additionalJwksUri',
        },
      ],
    },
    clerk: {
      issuer: 'issuer',
      jwksUri: 'jwksUri',
    },
  },
  globalMaxActiveProjectsCap: 5,
}
